module.exports = __webpack_public_path__ + "img/logo.101e7fe3.svg";